<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="KemperLima_1d0d0_4erKaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from "@/components/Simulation";
import KemperLima_1d0d0 from "@/device-products/KemperLima_1d0d0.vue";

const anzahlTeilnehmer = 4;

function getConnections() {
  return Array.from(new Array(anzahlTeilnehmer - 1), (_, index) => {
    return {
      id: `Station ${index + 1} zu Station ${index + 2}`,
      from: { deviceId: index, uart: 1},
      to: { deviceId: index + 1, uart: 1 },
    };
  });
}

function getSimulationDevices() {
  return Array.from(new Array(anzahlTeilnehmer), (_, index) => {
    return {
      id: index,
      component: KemperLima_1d0d0,
      deviceLabel: (index === 0) ? 'Station 1 - Master' : `Station ${index + 1}`,
    };
  });
}

export default {
  components: {
    Simulation
  },

  data: () => ({
    busConfigurations: [
      {
        label: "Kaskade",
        connections: [
          ...getConnections(),
        ],
      }
    ],
    simulationDevices: [
      ...getSimulationDevices(),
    ],
  })
};
</script>

<style></style>
